import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import differenceInSeconds from "date-fns/differenceInSeconds";

// AWS
import { API, Storage, Auth } from "aws-amplify";

function useBroadCast({ type }) {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, [type]);

  const getData = async (
    where = {},
    options = { sortBy: "", isLoading: true }
  ) => {
    try {
      setLoading(options.isLoading);
      const datas = await API.get("MoneyHubAdmin", "/broadcast", {
        queryStringParameters: {
          ...where,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(datas.body);
      let newDatas = await Promise.all(
        parseData?.Items?.map(async (data) => {
          return {
            ...data,
          };
        })
      );

      let convertType = type === "normal" ? "N" : "D";
      const filterDatas = newDatas.filter((data) => data.type === convertType);
      setDatas(filterDatas);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    datas,
    setDatas,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useBroadCast;
